import styled from 'styled-components';
import { IonContent } from '@ionic/react';
import Footer from '$gcomponents/widgets/footer';
import { SPACE, WEIGHT } from '$gstyles';
import { mobileStyle } from '$gstyles/utils';

export const IonContentWrapper = styled(IonContent)`
  --overflow: auto;

  .item-container {
    flex-direction: column;
    align-items: center;
    padding-top: ${SPACE.LARGE};
    height: 100%;

    .image-section {
      /* height: ${(p) => p.imageSize || 280}px; */
      width: 100%;
      display: flex;
      flex: 1;
      justify-content: center;
      .main-image {
        margin: 0 ${SPACE.LARGE};
        min-height: ${(p) => (p.imageSize && !p.imageSize.includes('%')) || '250px'};
        /* box-shadow: 2px 2px 4px #666; */
      }
      .left {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        margin-right: -10px;
        min-width: ${(p) => p.thumbSize + 20 + 'px' || '64px'};
        height: ${(p) => p.imageSize || '250px'};
        padding-left: ${SPACE.MEDIUM};
        overflow: auto;
      }
      .thumb {
        margin-bottom: 5px;
        border: 5px solid transparent;
        box-shadow: 1px 1px 2px #999;
        box-sizing: border-box;
      }
      .thumb.selected {
        border-color: var(--ion-color-);
        border-width: 5px;
      }
    }

    .memo-section {
      padding-top: ${SPACE.LARGE};
      textarea {
        width: 100%;
        height: 100%;
        padding: 10px;
      }
    }

    .content-section {
      font-size: 16px;
      width: 100%;
      min-height: 110px;
      max-height: 240px;
      padding: ${SPACE.LARGE} ${SPACE.XLARGE};
      .item-name {
        font-size: 1.4em;
        font-weight: ${WEIGHT.SEMI_BOLD};
        text-transform: uppercase;
        margin-bottom: ${SPACE.MEDIUM};
        text-align: center;
      }
      .description {
        margin-bottom: ${SPACE.MEDIUM};
        align-items: flex-start;
        .value {
          margin-bottom: ${SPACE.MEDIUM};
        }
      }
      .oos {
        margin-left: ${SPACE.LARGE};
      }
      .sku,
      .skid,
      .packing,
      .lotNo,
      .binNo {
        display: inline-block;
        margin-right: ${SPACE.LARGE};
        text-transform: uppercase;
        font-weight: ${WEIGHT.SEMI_BOLD};
        > span {
          opacity: 0.8em;
          font-weight: ${WEIGHT.NORMAL};
        }
      }
      .quantity {
        margin: ${SPACE.LARGE} 0;
        justify-content: flex-start;
        .label {
          margin-right: ${SPACE.LARGE};
        }
      }
      .price-section {
        display: flex;
        align-items: center;
        .price {
          font-size: 36px;
          font-weight: ${WEIGHT.BOLD};
          margin-right: ${SPACE.LARGE};
        }
        .tag {
        }
      }
    }
  }

  .modifiers-section {
    width: 100%;
    padding: ${SPACE.LARGE} ${SPACE.XLARGE};
    padding-top: 0;

    .modifiers-title {
      font-size: 1.2em;
      font-weight: ${WEIGHT.SEMI_BOLD};
      margin-bottom: ${SPACE.MEDIUM};
      color: var(--ion-color-primary);
    }

    .modifier-group {
      margin-bottom: ${SPACE.LARGE};
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      padding: ${SPACE.MEDIUM};
      background-color: #fafafa;

      .modifier-group-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: ${SPACE.MEDIUM};
        padding-bottom: ${SPACE.SMALL};
        border-bottom: 1px solid #e0e0e0;

        .modifier-group-name {
          font-size: 1.1em;
          font-weight: ${WEIGHT.SEMI_BOLD};
        }

        .modifier-group-info {
          font-size: 0.9em;
          color: #666;
        }

        .required {
          color: #f44336;
          margin-left: 4px;
        }
      }

      .modifier-list {
        display: flex;
        flex-direction: column;
        gap: ${SPACE.SMALL};

        .modifier-item {
          display: flex;
          align-items: center;
          padding: ${SPACE.SMALL} ${SPACE.MEDIUM};
          border-radius: 8px;
          cursor: pointer;
          transition: background-color 0.2s;

          &:hover {
            background-color: #f5f5f5;
          }

          .modifier-check {
            display: flex;
            align-items: center;
            margin-right: ${SPACE.MEDIUM};

            .check-icon {
              font-size: 24px;
              color: #999;
            }
          }

          .modifier-name {
            flex: 1;
            font-size: 1em;
          }

          .quantity-indicator {
            font-size: 0.9em;
            color: #666;
            margin-right: ${SPACE.SMALL};
            font-weight: ${WEIGHT.SEMI_BOLD};
          }

          .modifier-price {
            font-weight: ${WEIGHT.SEMI_BOLD};
            color: var(--ion-color-primary);
            min-width: 60px;
            text-align: right;
          }
        }
      }
    }
  }

  ${mobileStyle(`
    .content-section {
      padding: ${SPACE.LARGE};
    }
  `)}
`;

export const IonFooterWrapper = styled(Footer)``;
